/**
 * components/wishlist/vibe-chip.tsx
 *
 * Small inline chip showing the vibe name with its color token.
 * Used in the done archive and item detail sheet.
 */
import type { WishlistVibe } from '@just-us/shared'

interface VibeChipProps {
  vibe: WishlistVibe
}

const VIBE_META: Record<WishlistVibe, { label: string; icon: string; bg: string; border: string; text: string; accent: string }> = {
  wander:   { label: 'Wander',   icon: '🌍', bg: 'var(--vibe-wander-bg)',   border: 'var(--vibe-wander-border)',   text: 'var(--vibe-wander-text)',   accent: 'var(--vibe-wander-accent)' },
  watch:    { label: 'Watch',    icon: '🎬', bg: 'var(--vibe-watch-bg)',    border: 'var(--vibe-watch-border)',    text: 'var(--vibe-watch-text)',    accent: 'var(--vibe-watch-accent)' },
  taste:    { label: 'Taste',    icon: '🍽️', bg: 'var(--vibe-taste-bg)',    border: 'var(--vibe-taste-border)',    text: 'var(--vibe-taste-text)',    accent: 'var(--vibe-taste-accent)' },
  weekend:  { label: 'Weekend',  icon: '🛋️', bg: 'var(--vibe-weekend-bg)',  border: 'var(--vibe-weekend-border)',  text: 'var(--vibe-weekend-text)',  accent: 'var(--vibe-weekend-accent)' },
  try:      { label: 'Try',      icon: '🎯', bg: 'var(--vibe-try-bg)',      border: 'var(--vibe-try-border)',      text: 'var(--vibe-try-text)',      accent: 'var(--vibe-try-accent)' },
  together: { label: 'Together', icon: '💝', bg: 'var(--vibe-together-bg)', border: 'var(--vibe-together-border)', text: 'var(--vibe-together-text)', accent: 'var(--vibe-together-accent)' },
}

export default function VibeChip({ vibe }: VibeChipProps) {
  const meta = VIBE_META[vibe]
  return (
    <span
      className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-full text-[11px] font-['DM_Sans'] font-medium border"
      style={{ background: meta.bg, borderColor: meta.border, color: meta.text }}
    >
      <span>{meta.icon}</span>
      {meta.label.toLowerCase()}
    </span>
  )
}

export { VIBE_META }
export type { VibeChipProps }
